import dayjs from 'dayjs';
import { DateItem } from '.';

export const getWeekRange = (date: dayjs.Dayjs) => {
  const day = date.day();
  const diffToSat = (day + 1) % 7;
  const start = date.startOf('day').subtract(diffToSat, 'day');
  const end = start.add(6, 'day');
  return [start, end];
};

// 获取当前周期的开始时间（最近的周六0点）
export const getCurrentCycleStart = () => {
  const now = dayjs();
  let saturday = now.day(6).hour(0).minute(0).second(0).millisecond(0);

  // 如果今天是周六且已过0点，或已经过了周六，则取下一个周六
  if ((now.day() === 6 && now.hour() >= 0) || now.day() > 6) {
    saturday = saturday.add(7, 'day');
  }

  return saturday;
};

// 生成日期范围内的所有日期对象
export const generateDateList = (timeRange: [dayjs.Dayjs, dayjs.Dayjs | null]): DateItem[] => {
  const dates: DateItem[] = [];
  const diff = timeRange[1] ? timeRange[1].diff(timeRange[0], 'day') + 1 : 0;

  Array.from({ length: diff }).forEach((_, index) => {
    const date = timeRange[0].add(index, 'day');
    dates.push({
      date: dayjs(date).format('YYYY-MM-DD'),
    });
  });

  return dates;
};
export const formatTimeRangesWithTomorrow = (
  date: string,
  timeRanges: { startDateTime: string; endDateTime: string }[]
) => {
  const today = new Date(date);
  const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
  const formatDate = (date: Date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

  return timeRanges.map((range: { startDateTime: string; endDateTime: string }) => {
    let startDate = formatDate(today);
    let endDate = formatDate(today);
    let startTimeStr = range.startDateTime.replace('次日', '').trim();
    let endTimeStr = range.endDateTime.replace('次日', '').trim();
    if (range.startDateTime.includes('次日')) {
      startDate = formatDate(tomorrow);
    }
    if (range.endDateTime.includes('次日')) {
      endDate = formatDate(tomorrow);
    }
    return {
      startDateTime: `${startDate}T${startTimeStr}:00`,
      endDateTime: `${endDate}T${endTimeStr}:00`,
    };
  });
};

// 还原时间段为带次日前缀的字符串
export const transformTimeRangesWithTomorrow = (
  baseDate: string,
  timeRanges: { startDateTime: string; endDateTime: string }[]
) => {
  const base = dayjs(baseDate);
  return timeRanges.map(range => {
    const start = dayjs(range.startDateTime);
    const end = dayjs(range.endDateTime);
    const isStartNextDay = start.isAfter(base, 'day');
    const isEndNextDay = end.isAfter(base, 'day');
    const startStr = (isStartNextDay ? '次日' : '') + start.format('HH:mm');
    const endStr = (isEndNextDay ? '次日' : '') + end.format('HH:mm');
    return {
      startDateTime: startStr,
      endDateTime: endStr,
    };
  });
};

// 格式化时间显示
export const formatTimeRange = (baseTime: string, startTime?: string, endTime?: string) => {
  if (!startTime || !endTime) return;
  const base = dayjs(baseTime);
  const start = dayjs(startTime);
  const end = dayjs(endTime);

  // 判断开始时间是否为次日
  const isStartNextDay = start.isAfter(base, 'day');
  // 判断结束时间是否为次日
  const isEndNextDay = end.isAfter(base, 'day');

  const startFormatted = isStartNextDay ? `次日${start.format('HH:mm')}` : start.format('HH:mm');
  const endFormatted = isEndNextDay ? `次日${end.format('HH:mm')}` : end.format('HH:mm');

  return `${startFormatted}-${endFormatted}`;
};

// str: "08:00-次日10:00" 或 "次日08:00-10:00"
// baseDate: "2025-11-28"
export function parseTimeRange(baseDate: string, str: string) {
  const [startRaw, endRaw] = str.split('-');
  const base = dayjs(baseDate);

  // 处理开始时间
  let startTime: dayjs.Dayjs;
  if (startRaw.startsWith('次日')) {
    startTime = base
      .add(1, 'day')
      .hour(Number(startRaw.slice(2, 4)))
      .minute(Number(startRaw.slice(5, 7)));
  } else {
    startTime = base.hour(Number(startRaw.slice(0, 2))).minute(Number(startRaw.slice(3, 5)));
  }

  // 处理结束时间
  let endTime: dayjs.Dayjs;
  if (endRaw.startsWith('次日')) {
    endTime = base
      .add(1, 'day')
      .hour(Number(endRaw.slice(2, 4)))
      .minute(Number(endRaw.slice(5, 7)));
  } else {
    endTime = base.hour(Number(endRaw.slice(0, 2))).minute(Number(endRaw.slice(3, 5)));
  }

  return {
    startDateTime: startTime.format('YYYY-MM-DDTHH:mm:ss'),
    endDateTime: endTime.format('YYYY-MM-DDTHH:mm:ss'),
  };
}
